/* Utilismo · KL Celular — loja com cara de app no celular (só até 989px) */
  (function () {
    var cfg = window.klCelCfg || {};
    if (!cfg.meta) cfg.meta = 19900;
    var K = window.__klCel = window.__klCel || {};
    var mq = window.matchMedia('(max-width: 989px)');
    var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var CAMINHAO = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';

    function vibra(p) { if (!cfg.vibrar) return; try { if (navigator.vibrate) navigator.vibrate(p); } catch (e) {} }
    function dinheiro(c) {
      var moeda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
      try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: moeda }); }
      catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    }
    function parcelas(c) {
      var n = 1;
      for (var i = 2; i <= 4; i++) { if (c / i >= 2000) n = i; }
      return n > 1 ? n + 'x de ' + dinheiro(Math.ceil(c / n)) : '';
    }
    function reiniciarAnim(el, classe) { if (!el) return; el.classList.remove(classe); void el.offsetWidth; el.classList.add(classe); }

    /* ---------- Carrinho: contador, aviso e frete ---------- */
    K.ultimo = K.ultimo || cfg.carrinho || { item_count: 0, total_price: 0 };
    function contador(n) {
      [].forEach.call(document.querySelectorAll('[data-kl-qtd]'), function (b) {
        b.textContent = n > 99 ? '99+' : n;
        b.hidden = !n;
      });
    }
    function buscarCarrinho() {
      var f = K.fetch || window.fetch;
      return f(raiz + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var antes = K.ultimo ? K.ultimo.total_price : c.total_price;
          K.ultimo = c;
          contador(c.item_count);
          freteGaveta(c);
          if (cfg.frete && antes < cfg.meta && c.total_price >= cfg.meta) setTimeout(liberouFrete, 450);
          return c;
        })
        .catch(function () { return K.ultimo; });
    }

    function confete(alvo, x, y) {
      if (!alvo || calmo) return;
      var box = document.createElement('span');
      box.className = 'kl-confete';
      var cores = ['#C9502E', '#F2B544', '#25D366', '#222222', '#E2D5C6', '#FA7E1E'];
      for (var i = 0; i < 22; i++) {
        var p = document.createElement('i');
        p.style.setProperty('--x0', x || '50%');
        p.style.setProperty('--y0', y || '50%');
        p.style.setProperty('--c', cores[i % cores.length]);
        p.style.setProperty('--dx', Math.round(Math.random() * 240 - 120) + 'px');
        p.style.setProperty('--dy', Math.round(-30 - Math.random() * 80) + 'px');
        p.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
        p.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
        box.appendChild(p);
      }
      alvo.appendChild(box);
      setTimeout(function () { box.remove(); }, 1500);
    }
    function liberouFrete() {
      vibra([20, 40, 20, 40, 30]);
      var t = document.querySelector('.kl-toast.is-on');
      var cd = document.querySelector('cart-drawer.active .kl-fg');
      if (cd) confete(cd, 'calc(100% - 2rem)', '70%');
      else if (t) confete(t, '20%', '50%');
    }

    function freteGaveta(c) {
      if (!cfg.frete || !c) return;
      var inner = document.querySelector('cart-drawer .drawer__inner');
      if (!inner) return;
      var el = inner.querySelector('[data-kl-fg]');
      var novo = false;
      if (!el) {
        novo = true;
        el = document.createElement('div');
        el.className = 'kl-fg';
        el.setAttribute('data-kl-fg', '');
        el.innerHTML = '<p class="kl-fg__txt" data-kl-fg-txt></p><div class="kl-fg__trilho"><span class="kl-fg__barra"></span><span class="kl-fg__caminhao">' + CAMINHAO + '</span></div>';
        el.style.setProperty('--p', K.fgP || 0);
        var head = inner.querySelector('.drawer__header');
        if (head) head.insertAdjacentElement('afterend', el);
        else inner.insertBefore(el, inner.firstChild);
      }
      var tot = c.total_price || 0;
      var p = Math.max(0, Math.min(1, tot / cfg.meta));
      var ok = tot >= cfg.meta;
      var txt = ok ? '🎉 Você ganhou <b>frete grátis!</b>' : 'Faltam <b>' + dinheiro(cfg.meta - tot) + '</b> pro <b>frete grátis</b> 🚚';
      var alvoTxt = el.querySelector('[data-kl-fg-txt]');
      if (alvoTxt.innerHTML !== txt) alvoTxt.innerHTML = txt;
      el.classList.toggle('is-ok', ok);
      var aplicar = function () { el.style.setProperty('--p', p.toFixed(3)); };
      if (novo) requestAnimationFrame(function () { requestAnimationFrame(aplicar); }); else aplicar();
      K.fgP = p.toFixed(3);
    }

    var toastEl = null, toastT = null;
    function esconderToast() { if (toastEl) toastEl.classList.remove('is-on'); }
    function mostrarToast(o, c) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'kl-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        toastEl.innerHTML = '<span class="kl-toast__img" data-kl-t-img></span><span class="kl-toast__txt"><strong>Adicionado!</strong><small data-kl-t-sub></small><span class="kl-toast__barra" data-kl-t-barra><i></i></span></span><button type="button" class="kl-toast__btn" data-kl-t-ver>Ver carrinho</button>';
        document.body.appendChild(toastEl);
        toastEl.querySelector('[data-kl-t-ver]').addEventListener('click', function () { esconderToast(); abrirGaveta(); });
      }
      var img = toastEl.querySelector('[data-kl-t-img]');
      img.style.backgroundImage = o && o.img ? 'url("' + String(o.img).replace(/"/g, '%22') + '")' : '';
      var sub = toastEl.querySelector('[data-kl-t-sub]');
      var barra = toastEl.querySelector('[data-kl-t-barra]');
      var tot = c ? c.total_price : 0;
      if (cfg.frete && c) {
        var ok = tot >= cfg.meta;
        sub.textContent = ok ? '🎉 Frete grátis liberado!' : 'Faltam ' + dinheiro(cfg.meta - tot) + ' pro frete grátis';
        barra.hidden = false;
        toastEl.classList.toggle('is-frete', ok);
        barra.firstChild.style.setProperty('--p', Math.min(1, tot / cfg.meta).toFixed(3));
      } else {
        sub.textContent = c ? c.item_count + (c.item_count === 1 ? ' item' : ' itens') + ' · ' + dinheiro(tot) : '';
        barra.hidden = true;
      }
      requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
      clearTimeout(toastT);
      toastT = setTimeout(esconderToast, 4200);
    }

    function abrirGaveta() {
      var cd = document.querySelector('cart-drawer');
      var abrir = cd && (cd.__klOpen || cd.open);
      if (typeof abrir !== 'function') return false;
      abrir.call(cd, document.getElementById('cart-icon-bubble') || undefined);
      return true;
    }

    /* Botão + dos produtos: não abre o carrinho, a foto voa e aparece o aviso */
    function patchGaveta() {
      var cd = document.querySelector('cart-drawer');
      if (!cd || cd.__klOpen || typeof cd.open !== 'function') return;
      cd.__klOpen = cd.open;
      cd.open = function () {
        if (Date.now() < (K.semGavetaAte || 0)) { K.semGavetaAte = 0; return; }
        return cd.__klOpen.apply(cd, arguments);
      };
    }

    function alvoCarrinho() {
      var tb = document.querySelector('[data-kl-tb]');
      if (!tb) return null;
      if (tb.classList.contains('is-compra')) return tb.querySelector('[data-kl-add-prod]');
      return tb.querySelector('[data-kl-alvo]');
    }
    function pular() {
      var tb = document.querySelector('[data-kl-tb]');
      if (!tb) return;
      mostrarBarra(true);
      var alvo = alvoCarrinho();
      if (!alvo) return;
      reiniciarAnim(alvo.querySelector('.kl-tb__qtd'), 'is-pula');
      if (alvo.classList.contains('kl-tb__ic')) reiniciarAnim(alvo, 'is-chacoalha');
      if (calmo) return;
      var r = alvo.getBoundingClientRect();
      var m = document.createElement('span');
      m.className = 'kl-mais1';
      m.textContent = '+1';
      m.style.left = (r.left + r.width / 2) + 'px';
      m.style.top = (r.top - 8) + 'px';
      document.body.appendChild(m);
      setTimeout(function () { m.remove(); }, 950);
    }
    function voar(o, fim) {
      var alvo = alvoCarrinho();
      if (!o || !o.el || !alvo || calmo || !o.el.isConnected) { fim(); return; }
      var tb = document.querySelector('[data-kl-tb]');
      var ty = 0;
      try { ty = new DOMMatrixReadOnly(getComputedStyle(tb).transform).m42 || 0; } catch (e) {}
      mostrarBarra(true);
      var a = o.el.getBoundingClientRect();
      var b = alvo.getBoundingClientRect();
      var tam = 56;
      var x0 = a.left + a.width / 2 - tam / 2, y0 = a.top + a.height / 2 - tam / 2;
      var x1 = b.left + b.width / 2 - tam / 2, y1 = b.top - ty + b.height / 2 - tam / 2;
      var w = document.createElement('div');
      w.className = 'kl-voo';
      w.style.left = x0 + 'px';
      w.style.top = y0 + 'px';
      var bola = document.createElement('div');
      bola.className = 'kl-voo__bola';
      if (o.img) bola.style.backgroundImage = 'url("' + String(o.img).replace(/"/g, '%22') + '")';
      w.appendChild(bola);
      document.body.appendChild(w);
      if (!w.animate) { w.remove(); fim(); return; }
      var dur = 780;
      w.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (x1 - x0) + 'px)' }], { duration: dur, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', fill: 'forwards' });
      var anim = bola.animate([
        { transform: 'translateY(0) scale(1)', opacity: 1 },
        { transform: 'translateY(' + (y1 - y0) + 'px) scale(0.32)', opacity: 0.9 }
      ], { duration: dur, easing: 'cubic-bezier(0.5, -0.7, 0.8, 0.55)', fill: 'forwards' });
      anim.onfinish = function () { w.remove(); fim(); };
    }

    function aoAdicionar() {
      if (!mq.matches) { K.origem = null; K.semGavetaAte = 0; return; }
      var o = K.origem && Date.now() - K.origem.t < 9000 ? K.origem : null;
      K.origem = null;
      var aviso = !!(o && o.aviso);
      if (o && o.el) {
        o.el.classList.add('kl-ok');
        setTimeout(function () { o.el.classList.remove('kl-ok'); }, 1600);
      }
      var pc = buscarCarrinho();
      vibra([12, 40, 12]);
      if (aviso && mq.matches) {
        voar(o, function () { pular(); });
        pc.then(function (c) { mostrarToast(o, c); });
      } else {
        pc.then(function () { pular(); });
      }
    }
    function aoMudar() { if (mq.matches) buscarCarrinho(); }

    if (!K.global) {
      K.global = true;
      /* Escuta o carrinho sem mexer nos scripts do tema */
      if (window.fetch) {
        K.fetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
          var p = K.fetch.apply(window, arguments);
          try {
            var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
            var m = ((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
            var add = url.indexOf('/cart/add') > -1;
            if (m === 'POST' && (add || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1)) {
              p.then(function (r) {
                if (r && r.ok) setTimeout(function () { if (add) aoAdicionar(); else aoMudar(); }, 0);
                else if (add) { K.semGavetaAte = 0; K.origem = null; }
              }, function () { if (add) { K.semGavetaAte = 0; K.origem = null; } });
            }
          } catch (e) {}
          return p;
        };
      }
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patchGaveta);

      document.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var b = e.target.closest('.card-wrapper .quick-add__submit, .kl-card [data-pl-add]');
        if (!b || b.disabled || b.hasAttribute('data-product-url')) return;
        var card = b.closest('.card-wrapper, .kl-card');
        var img = card && card.querySelector('img');
        K.origem = { el: b, img: img ? (img.currentSrc || img.src) : '', t: Date.now(), aviso: cfg.voar };
        if (cfg.voar) K.semGavetaAte = Date.now() + 6000;
      }, true);

      /* Recoloca a barra de frete quando o carrinho é redesenhado */
      var cdObs = function () {
        var cd = document.querySelector('cart-drawer');
        if (!cd || !cfg.frete || !('MutationObserver' in window)) return;
        var pend = false;
        new MutationObserver(function () {
          if (pend) return;
          pend = true;
          requestAnimationFrame(function () {
            pend = false;
            if (!cd.querySelector('[data-kl-fg]')) freteGaveta(K.ultimo);
          });
        }).observe(cd, { childList: true, subtree: true });
        freteGaveta(K.ultimo);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cdObs); else cdObs();
    }

    /* ---------- Barra de baixo ---------- */
    var tb = document.querySelector('[data-kl-tb]');
    if (!tb) return;
    var nav = tb.querySelector('[data-kl-face="nav"]');
    var faceCompra = tb.querySelector('[data-kl-face="compra"]');
    var bolha = tb.querySelector('[data-kl-bolha]');
    var anel = tb.querySelector('[data-kl-anel]');
    var pt = tb.getAttribute('data-pt');

    function moverBolha(aba, semAnim) {
      if (!bolha) return;
      if (!aba) { bolha.style.opacity = 0; return; }
      var r = aba.getBoundingClientRect(), f = nav.getBoundingClientRect();
      if (!r.width) return;
      var w = Math.min(r.width - 4, 64);
      if (semAnim) bolha.classList.add('sem-anim');
      bolha.style.width = w + 'px';
      bolha.style.transform = 'translateX(' + (r.left - f.left + (r.width - w) / 2) + 'px)';
      bolha.style.opacity = 1;
      if (semAnim) { void bolha.offsetWidth; bolha.classList.remove('sem-anim'); }
    }
    function abaAtiva() { return tb.querySelector('.kl-tb__aba.is-ativa'); }
    function ativar(a) {
      [].forEach.call(tb.querySelectorAll('.kl-tb__aba'), function (x) { x.classList.toggle('is-ativa', x === a); });
      moverBolha(a);
    }
    var abaInicial = abaAtiva();
    moverBolha(abaInicial, true);
    window.addEventListener('resize', function () { moverBolha(abaAtiva(), true); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moverBolha(abaAtiva(), true); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      [].forEach.call(tb.querySelectorAll('.kl-tb__aba'), function (x) { x.classList.toggle('is-ativa', x === abaInicial); });
      moverBolha(abaInicial, true);
      buscarCarrinho();
    });

    function abrirBusca() {
      var sm = document.querySelector('details-modal.header__search summary, .header__search summary');
      if (sm) { setTimeout(function () { sm.click(); }, 0); return true; }
      return false;
    }

    tb.addEventListener('click', function (e) {
      var a = e.target.closest('[data-kl-aba]');
      if (!a) return;
      var k = a.getAttribute('data-kl-aba');
      reiniciarAnim(a, 'is-toque');
      vibra(8);
      if (k === 'inicio' && (tb.classList.contains('is-topo') || pt === 'index')) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: calmo ? 'auto' : 'smooth' });
        return;
      }
      if (k === 'buscar' && abrirBusca()) { e.preventDefault(); return; }
      if (k === 'carrinho' && pt !== 'cart' && abrirGaveta()) { e.preventDefault(); return; }
      if (a.target !== '_blank') ativar(a);
    });

    /* Some ao rolar pra baixo, volta ao rolar pra cima */
    var escondida = false, travaAte = 0;
    function mostrarBarra(travar) {
      if (travar) travaAte = Date.now() + 1800;
      if (!escondida) return;
      escondida = false;
      tb.classList.remove('is-escondida');
    }
    function esconderBarra() {
      if (escondida || Date.now() < travaAte) return;
      if (toastEl && toastEl.classList.contains('is-on')) return;
      escondida = true;
      tb.classList.add('is-escondida');
    }

    /* Página do produto: depois do botão de compra, a barra vira "Comprar" */
    var faceAtual = 'nav';
    var kc = null, bAgora = null, bCar = null, alvoCompra = null;
    function face(f) {
      if (!faceCompra || f === faceAtual) return;
      faceAtual = f;
      var c = f === 'compra';
      tb.classList.toggle('is-compra', c);
      faceCompra.toggleAttribute('inert', !c);
      faceCompra.setAttribute('aria-hidden', c ? 'false' : 'true');
      nav.toggleAttribute('inert', c);
      nav.setAttribute('aria-hidden', c ? 'true' : 'false');
    }
    if (faceCompra) {
      kc = document.querySelector('main [data-kl-compra]');
      if (kc) {
        bAgora = kc.querySelector('[data-kl-agora]');
        bCar = kc.querySelector('[data-kl-carrinho]');
        alvoCompra = kc;
      } else {
        bAgora = bCar = document.querySelector('main .product-form__submit, main product-form button[name="add"]');
        alvoCompra = bAgora && (bAgora.closest('product-form') || bAgora);
      }
      var precoEl = faceCompra.querySelector('[data-kl-preco]');
      var parcEl = faceCompra.querySelector('[data-kl-parc]');
      var bComprar = faceCompra.querySelector('[data-kl-comprar]');
      var tComprar = faceCompra.querySelector('[data-kl-comprar-txt]');
      var bAdd = faceCompra.querySelector('[data-kl-add-prod]');
      var sinc = function () {
        if (!bAgora) return;
        var tot = kc && kc.querySelector('[data-kl-total]');
        if (tot) {
          var dig = (tot.textContent || '').replace(/[^0-9]/g, '');
          if (dig) { var c = parseInt(dig, 10); precoEl.textContent = dinheiro(c); parcEl.textContent = parcelas(c); }
        }
        var carregando = bAgora.classList.contains('is-carregando');
        var esgotado = bAgora.disabled && !carregando;
        bComprar.disabled = esgotado;
        bComprar.classList.toggle('is-carregando', carregando);
        tComprar.textContent = carregando ? 'Indo…' : esgotado ? 'Esgotado' : 'Comprar';
        if (bCar) {
          var cc = bCar.classList.contains('is-carregando');
          bAdd.disabled = bCar.disabled && !cc;
          bAdd.classList.toggle('is-carregando', cc);
        }
      };
      if (kc && 'MutationObserver' in window) {
        var pendS = false;
        new MutationObserver(function () {
          if (pendS) return;
          pendS = true;
          requestAnimationFrame(function () { pendS = false; sinc(); });
        }).observe(kc, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'hidden'] });
      }
      sinc();
      bComprar.addEventListener('click', function () {
        vibra(10);
        if (bAgora && !bAgora.disabled) bAgora.click();
      });
      bAdd.addEventListener('click', function () {
        vibra(10);
        if (bCar && !bCar.disabled) bCar.click();
      });
      faceCompra.querySelector('[data-kl-ir-fotos]').addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: calmo ? 'auto' : 'smooth' });
      });
    }

    var ultY = window.pageYOffset || 0, dir = 0, acum = 0, pend = false;
    function noScroll() {
      pend = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var dy = y - ultY;
      ultY = y;
      var altura = document.documentElement.scrollHeight - window.innerHeight;
      var topo = y > window.innerHeight * 1.4;
      tb.classList.toggle('is-topo', topo);
      if (anel) anel.style.strokeDashoffset = String(100 - Math.round(Math.min(1, y / Math.max(1, altura)) * 100));
      if (Math.abs(dy) < 1) return;
      var d = dy > 0 ? 1 : -1;
      if (d !== dir) { dir = d; acum = 0; }
      acum += Math.abs(dy);
      var noFim = y >= altura - 60;
      var rc = alvoCompra ? alvoCompra.getBoundingClientRect() : null;
      var passou = rc ? rc.bottom < 0 : false;
      /* Botão de compra da página ainda abaixo da tela: a barra já mostra "Comprar" */
      var abaixo = rc && cfg.compraJa !== false ? rc.top > window.innerHeight - 40 : false;
      if (abaixo) {
        face('compra');
        mostrarBarra();
      } else if (passou) {
        mostrarBarra();
        if (dir > 0 && acum > 24) face('compra');
        else if (dir < 0 && acum > 110 && !noFim) face('nav');
      } else {
        face('nav');
        if (!cfg.esconder || y < 140 || noFim) mostrarBarra();
        else if (dir > 0 && acum > 50) esconderBarra();
        else if (dir < 0 && acum > 24) mostrarBarra();
      }
    }
    window.addEventListener('scroll', function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(noScroll);
    }, { passive: true });
    noScroll();
    /* Ao abrir a página do produto, a barra já começa em "Comprar" (o botão da página fica abaixo da tela) */
    function compraInicial() {
      if (!alvoCompra || cfg.compraJa === false || !mq.matches) return;
      if (alvoCompra.getBoundingClientRect().top > window.innerHeight - 40) { face('compra'); mostrarBarra(); }
    }
    compraInicial();
    window.addEventListener('load', compraInicial);

    /* ---------- Dica de deslizar nos carrosséis ---------- */
    function dicas() {
      if (!cfg.dica || calmo || !mq.matches || !('IntersectionObserver' in window)) return;
      try { if (sessionStorage.getItem('kl-dica')) return; } catch (e) {}
      var trilhos = [].filter.call(document.querySelectorAll('main .kl-vit__trilho, main [data-pl-track]:not(.kl-slides__trilho)'), function (t) {
        return t.scrollWidth > t.clientWidth + 40;
      });
      if (!trilhos.length) return;
      var feito = false;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (feito || !en.isIntersecting || en.intersectionRatio < 0.6) return;
          var t = en.target;
          if (t.scrollLeft > 4) return;
          feito = true;
          io.disconnect();
          try { sessionStorage.setItem('kl-dica', '1'); } catch (x) {}
          setTimeout(function () { cutucar(t); }, 450);
        });
      }, { threshold: [0.6] });
      trilhos.forEach(function (t) { io.observe(t); });
    }
    function cutucar(t) {
      var pai = t.parentNode;
      if (getComputedStyle(pai).position === 'static') pai.style.position = 'relative';
      var dica = document.createElement('span');
      dica.className = 'kl-dica';
      dica.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>Deslize pro lado';
      pai.appendChild(dica);
      t.classList.add('kl-cutuca');
      var limpar = function () { t.classList.remove('kl-cutuca'); dica.remove(); };
      setTimeout(function () { t.classList.remove('kl-cutuca'); }, 1700);
      setTimeout(function () { dica.remove(); }, 2700);
      t.addEventListener('touchstart', limpar, { once: true, passive: true });
    }
    if (document.readyState === 'complete') setTimeout(dicas, 600);
    else window.addEventListener('load', function () { setTimeout(dicas, 600); });
  })();
